import { useState } from "react";
import { useI18n } from "../../i18n";
import "./agent-info.scss";

interface AgentInfoProps {
  toolUrl: string;
  toolName: string;
  description: string;
  steps: string[];
}

export function AgentInfo({ toolUrl, toolName, description, steps }: AgentInfoProps) {
  const { translations } = useI18n();
  const t = translations.tools.agentInfo;
  const [copied, setCopied] = useState(false);

  const fullUrl = `https://garaujo.dev${toolUrl}`;

  const handleCopyUrl = async () => {
    await navigator.clipboard.writeText(fullUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="agent-info">
      <h3 className="agent-info__title">{t.title}</h3>
      <p className="agent-info__desc">{t.description}</p>

      <div className="agent-info__card">
        <div className="agent-info__row">
          <span className="agent-info__label">Tool</span>
          <span className="agent-info__value">{toolName}</span>
        </div>
        <div className="agent-info__row">
          <span className="agent-info__label">URL</span>
          <span className="agent-info__url-group">
            <code className="agent-info__url">{fullUrl}</code>
            <button className="agent-info__copy" onClick={handleCopyUrl}>
              {copied ? t.copied : t.copy}
            </button>
          </span>
        </div>
        <div className="agent-info__row">
          <span className="agent-info__label">{t.descriptionLabel}</span>
          <span className="agent-info__value">{description}</span>
        </div>
      </div>

      <div className="agent-info__steps">
        <h4 className="agent-info__steps-title">{t.howToUse}</h4>
        <ol className="agent-info__list">
          {steps.map((step, i) => (
            <li key={i}>{step}</li>
          ))}
        </ol>
      </div>
    </div>
  );
}
